module.exports = __webpack_public_path__ + "img/COLLAR PURPLE.c8e4f87.svg";